import { gql } from '@apollo/client';

export const GET_ALL_SITE_VISIT_OPTIONS = gql`
  query {
    getSiteVisitOptions {
      id
      displayName
      status
    }
  }
`;

export const GET_SITE_VISIT_OPTION = gql`
  query GetSiteVisitOption($optionId: String!) {
    getSiteVisitOption(optionId: $optionId) {
      id
      displayName
      status
      createdUser
      createdTs
      lastUpdatedUser
      lastUpdatedTs
      entries {
        code
        description
        status
      }
    }
  }
`;

export const SAVE_SITE_VISIT_OPTION = gql`
  mutation SaveSiteVisitOption($input: SiteVisitOptionInput!) {
    saveSiteVisitOption(input: $input) {
      id
      displayName
      status
    }
  }
`;

